import React from 'react';
import clsx from 'clsx'

// Material UI
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import useStyles from "./styles";

const Spinner = ({ lockScreen, message, alpha = 0.35 }) => {
    const classes = useStyles({ alpha });
    
    const className = clsx(classes.icon, {
        [classes.screen]: lockScreen
    })

    return (
        <div className={className}>
            <CircularProgress />
            { 
                message &&
                <Typography 
                    className={classes.message}
                    variant='h6'
                >
                    {message}
                </Typography>
            }
        </div>
    )
}

export default Spinner;